import { Component, input, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { FeedbackTitleComponent } from '../feedback-title/feedback-title.component';
import { QuestionItem } from '../../feedback-types';
import { Subscription } from 'rxjs';
import { wildcardId } from '../../../../utils/feedback/feedback';

@Component({
  selector: 'app-feedback-radio',
  imports: [ReactiveFormsModule, FeedbackTitleComponent],
  templateUrl: './feedback-radio.component.html',
  styleUrl: './feedback-radio.component.css',
})
export class FeedbackRadioComponent implements OnInit, OnDestroy {
  private controlContainer = inject(ControlContainer);

  public question = input.required<QuestionItem>();
  protected form!: FormGroup;
  protected additionalInfo = signal('');
  protected controlErrors = signal<ValidationErrors | null>(null);
  protected formControlName = '';
  private isUpdatingValidators = false;
  private valueChangesSubscription!: Subscription;

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    this.formControlName = this.question().id;
    const control = this.form.get(this.formControlName);
    this.valueChangesSubscription = control!.valueChanges.subscribe((value) => {
      if (!this.isUpdatingValidators) {
        // Prevent infinite loop, as setting validators triggers valueChanges
        this.isUpdatingValidators = true;
        this.updateValidators(value, control!);
      }
    });
    const wildcard = this.question().wildcard;
    if (wildcard && control?.value) {
      const currentSelected = control.value as string;

      // Check if it starts with the wildcard id
      if (currentSelected.startsWith(wildcardId)) {
        this.additionalInfo.set(currentSelected.replace(wildcardId, ''));
        control.setValue(wildcardId + this.additionalInfo());
      }
    }
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
  }

  updateAdditionalInfo(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.additionalInfo.set(inputElement.value);
    const control = this.form.get(this.formControlName);
    const wildcard = this.question().wildcard;
    if (control && wildcard) {
      control.setValue(wildcardId + this.additionalInfo());
    }
  }

  private updateValidators(selectedValue: string, control: AbstractControl): void {
    const wildcard = this.question().wildcard;
    if (wildcard && selectedValue.startsWith(wildcardId)) {
      control.setValidators([this.customValidator.bind(this)]);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity();
    this.controlErrors.set(control.errors);
    this.isUpdatingValidators = false;
  }

  private customValidator(): ValidationErrors | null {
    const value = wildcardId + this.additionalInfo();
    return value === wildcardId ? { emptyWildcard: true } : null;
  }
}
